import { defineMessages } from 'react-intl';

export const codingAgentRecommendationMessages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	setUpIn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chooseProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'jira-coding-agent-recommendation.title',
		defaultMessage: 'Write code and review PRs automatically',
		description: 'Title of the Jira Coding Agent recommendation message',
	},
	description: {
		id: 'jira-coding-agent-recommendation.description',
		defaultMessage:
			'Jira Coding Agent can review PRs attached to work to flag errors and suggest changes.',
		description: 'Body copy explaining what the Jira Coding Agent does.',
	},
	setUpIn: {
		id: 'jira-coding-agent-recommendation.set-up-in',
		defaultMessage: 'Set up in {projectName}',
		description: 'Primary action label; sets up the Coding Agent in the selected project',
	},
	chooseProject: {
		id: 'jira-coding-agent-recommendation.choose-space',
		defaultMessage: 'Choose a space',
		description: 'Accessible label for the space chooser dropdown',
	},
	dismiss: {
		id: 'jira-coding-agent-recommendation.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Accessible label for the dismiss (close) button',
	},
});
